import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '@components/PrimaryButton';
import { ROUTES } from '@constants';
import emptyOrder from '@assets/empty-order-bg.png';
import { useStyles, useStylesButton } from './styles';

const EmptyOrder = () => {
  const classes = useStyles();
  const classesButton = useStylesButton();
  const history = useHistory();
  const { t } = useTranslation('orderScreen');

  const handleNextPage = nextPath => {
    history.push(nextPath, {
      from: ROUTES.ORDERS_SCREEN,
    });
  };

  return (
    <div className={classes.container}>
      <img src={emptyOrder} alt="emptyOrder" />
      <div className={classes.textMessage}>You have nothing ordered yet!</div>
      <div className={classes.buttonGroup}>
        <PrimaryButton
          text="view menu"
          handleClick={() => handleNextPage(ROUTES.MENU_SCREEN)}
        />
        <p className={classes.buttonSeparator}>{t('or')}</p>
        <PrimaryButton
          classesButton={classesButton}
          text="cocktail finder"
          handleClick={() => handleNextPage(ROUTES.SLIDER_SCREEN)}
        />
      </div>
    </div>
  );
};

export default EmptyOrder;
